import { render } from "./ProductChat.vue?vue&type=template&id=228c0777&scoped=true&ts=true"
import script from "./ProductChat.vue?vue&type=script&lang=ts"
export * from "./ProductChat.vue?vue&type=script&lang=ts"

import "./ProductChat.vue?vue&type=style&index=0&id=228c0777&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/buildAgent/work/a701a23a46ecd31f/bookit-pms/Solution/Bookit.BO/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-228c0777"]])

export default __exports__